import vuetify, { i18n } from "@/plugins/vuetify";
import { LanguageModule } from "@/store/modules/LanguageVuexModule";
import {
  isSupportedLanguage,
  Language,
} from "@/i18n/LanguageTypes";

/**
 * The locale vocabulary and its validators live in `@/i18n/LanguageTypes`, which imports nothing.
 * They are re-exported here so the existing callers keep their import path, but anything that runs
 * during module initialization (notably `LanguageVuexModule`) must import them from the leaf
 * directly — see the note there for why.
 */
export {
  DEFAULT_LOCALE,
  isSupportedLanguage,
  Language,
  parseStoredLocale,
} from "@/i18n/LanguageTypes";

export const DEV_LANGUAGES = [
  Language.POLISH
];

export function getLanguageName(vue: Vue, language: Language): string {
  return vue.$t(
    `language.${language}`
  ).toString();
}

/**
 * Switches the app to `language`, persisting it for the next visit.
 *
 * The parameter is deliberately wider than `Language`: callers pass values straight out of
 * Firestore documents. An unsupported one is ignored rather than applied, because assigning it to
 * `i18n.locale` renders every string as its own key, and persisting it used to brick the next
 * app start.
 */
export function changeLanguageTo(language: Language | undefined | null) {
  if (!isSupportedLanguage(language)) {
    return;
  }

  if (language !== i18n.locale) {
    i18n.locale = language;
    vuetify.framework.lang.current = language;
    LanguageModule.setLocale(language);
  }
}
